import createWatcher from "./watcher";

let isVisible = true;

const { invisible, visible } = createWatcher();
const onHidden = () => { isVisible && (isVisible = false, invisible()) };
const onVisible = () => { !isVisible && (isVisible = true, visible()) };

const getHiddenProperty = prefix => (prefix ? `${prefix}Hidden` : "hidden");
const getVisibilityEvent = prefix => (`${(prefix ? prefix : "")}visibilitychange`);

// get current browser vendor prefix
const BROWSER_PREFIX = (() => {
  for (const prefix of ["moz", "ms", "o", "webkit"]) {
    if (getHiddenProperty(prefix) in document) return prefix;
  } return null;
})();

const HIDDEN_PROPERTY = getHiddenProperty(BROWSER_PREFIX);
const VISIBILITY_EVENT = getVisibilityEvent(BROWSER_PREFIX);

document.addEventListener(VISIBILITY_EVENT, () => {
  return (document[HIDDEN_PROPERTY] ? onHidden : onVisible)();
}, false);

// extra event listeners for better behaviour
document.addEventListener("focus", onVisible, false);
document.addEventListener("blur", onHidden, false);
window.addEventListener("focus", onVisible, false);
window.addEventListener("blur", onHidden, false);

// [SOURCES]:
// https://stereologics.wordpress.com/2015/04/02/about-page-visibility-api-hidden-visibilitychange-visibilitystate/
// https://stackoverflow.com/questions/28993157/visibilitychange-event-is-not-triggered-when-switching-program-window-with-altt
// https://stackoverflow.com/questions/1060008/is-there-a-way-to-detect-if-a-browser-window-is-not-currently-active/9502074#9502074
